// Utility to fetch user display name by email from Firestore
import { db } from '../firebase';


// Fetch full user record by email
export async function getUserByEmail(email: string): Promise<any | null> {
  if (!email) return null;
  const usersRef = db.collection('users');
  const query = usersRef.where('email', '==', email).limit(1);
  try {
    const snapshot = await query.get();
    if (!snapshot.empty) {
      return snapshot.docs[0].data();
    }
    return null;
  } catch (err: any) {
    // Likely a permissions error when the client is not allowed to read user records.
    // Log for diagnostics but do not throw so UI flows can continue and fallback behavior can run.
    console.warn('getUserByEmail failed (permissions?):', err && err.message ? err.message : err);
    return null;
  }
}
